import { render, staticRenderFns } from "./increaseTransactions.vue?vue&type=template&id=c12fe6f4&scoped=true&"
import script from "./increaseTransactions.vue?vue&type=script&lang=js&"
export * from "./increaseTransactions.vue?vue&type=script&lang=js&"
import style0 from "./increaseTransactions.vue?vue&type=style&index=0&lang=css&"
import style1 from "./increaseTransactions.vue?vue&type=style&index=1&id=c12fe6f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12fe6f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VBtnToggle,VExpandTransition,VFlex,VIcon,VRow})
